// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import axios from 'axios';     // ← Add this

import { AuthProvider, useAuth } from './AuthContext';
import AdminDashboard from './AdminDashboard.jsx';
import Login from './Login.jsx';
import HomePage from './HomePage.jsx';
import BoardPage from './BoardPage.jsx';      // NEW
import WhoWeArePage from './WhoWeArePage.jsx'; // NEW
import GalleryPage from './GalleryPage.jsx';    // NEW

const root = ReactDOM.createRoot(document.getElementById('root'));
axios.defaults.withCredentials = true;


function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        {/* NEW PUBLIC PAGES */}
        <Route path="/board" element={<BoardPage />} />
        <Route path="/employees" element={<WhoWeArePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);